import { Button, Input } from 'antd'
import React from 'react'
import { Label } from 'reactstrap'
import './StepFivePage.scss'
import { ArrowRightOutlined } from '@ant-design/icons'

const StepFivePage = ({ next }) => {
    const { TextArea } = Input;
    return (
        <div className='step5-section'>
            <h1>Why is this a <strong>fit</strong> for the Exitfund Accelerator?</h1>
            <form>
                <div className="form-field">
                    <Label>Why now?</Label>
                    <TextArea rows={4} className="textarea-field-input"
                        placeholder="50% of non-profits fail within the first few year. "
                        name="why-now"
                        type="textarea" />
                </div>
                <div className="form-field">
                    <Label>Why you?</Label>
                    <TextArea rows={4} className="textarea-field-input"
                        placeholder="I have raised $50M+ for non-profits and know the recipe. "
                        name="why-you"
                        type="text" />
                </div>
                <div className="form-field">
                    <Label>Why this program?</Label>
                    <TextArea rows={4} className="textarea-field-input"
                        placeholder="I would like to learn better on how to get accepted into YC.  "
                        name="why-program"
                        type="text" />
                </div>
                <Button
                    // loading={authLoading}
                    // disabled={!isEnabled}
                    onClick={next}
                    className="continue-button"
                >
                    Continue <ArrowRightOutlined />
                </Button>
            </form>
        </div>
    )
}

export default StepFivePage